import React from 'react';
import classNames from 'classnames';

import Moment from 'react-moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

import { Maintenance, Estimate, Quote } from './Total';

const styles = theme => ({
  root:{
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
    maxWidth: '800px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    margin: '10px',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  title: {
    flexGrow: 1,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  spacer: {
    marginRight: theme.spacing.unit*2,
    marginLeft: theme.spacing.unit*2,
  },
});


const JobTaskCard = ({classes, task, handleEdit}) => {
  return(
    <Card
      className={classes.root}
      onClick={() => handleEdit(task)}
    >
      <div className={classes.content}>
        <Avatar className={classNames(classes.avatar, classes.margin)}>
          {task.type && task.type.substring(0,1).toUpperCase()}
        </Avatar>
        <div className={classes.title}>
          {task.title &&
            <Typography variant="subheading">
              {task.title}
            </Typography>
          }
          {task.description &&
            <Typography variant="caption">
              {task.description}
            </Typography>
          }
        </div>
        {task.type === "maintenance" &&
          <div className={classes.row}>
            <Moment className={classes.margin} format="MMM Do, YYYY">{task.startDate}</Moment>
            <div className={classes.margin}>
              <Typography variant="subheading">
                Monthly
              </Typography>
              {task.scheduleOccurences &&
                <Typography variant="caption">
                  {`${task.scheduleOccurences} times`}
                </Typography>
              }
            </div>
            <Maintenance task={task} />
          </div>
        }
        {task.type === "estimate" &&
          <Estimate task={task} />
        }
        {task.type === "simple" &&
          <Estimate task={task} />
        }
        {task.type === "quote" &&
          <Quote task={task} />
        }
      </div>
      <div className={classes.spacer}>
        {task.optional === true &&
          <Typography variant="subheading">
            Optional
          </Typography>
        }
        {!task.optional &&
          <Typography variant="subheading">
            Required
          </Typography>
        }
      </div>
    </Card>

  );
};

export default withStyles(styles)(JobTaskCard);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobTaskCard.jsx